<template>
    <header :class="[
        'layout-header',
        'panel',
        layoutClasses,
        { 'is-extra-button': isAuth }
    ]">
        <div class="wrapper flex element-relative">
            <LogoDefault />
            <NavigationInfo />
            <ButtonSignout
                v-if="isAuth"
                @click.native="onClickSignout"
            />
        </div>
    </header>
</template>

<script>
import AuthService from '@/service/AuthService'
import ButtonSignout from '@/components/button/ButtonSignout'
import LogoDefault from '@/components/logo/LogoDefault'
import NavigationInfo from '@/components/navigation/NavigationInfo'

export default {
    components: {
        ButtonSignout,
        LogoDefault,
        NavigationInfo
    },

    computed: {
        isAuth() {
            return this.$store.getters['apiAuth/isAuth']
        },

        layoutClasses() {
            return this.$store.getters['layout/layoutClasses']
        }
    },

    methods: {
        onClickSignout() {
            AuthService.logout(this.$store, {}, () => {
                this.$router.push({ name: 'index' })
            })
        }
    }
}
</script>

<style lang="scss">
.layout-header {
    height: $value-height-header;
    position: fixed;
    box-shadow: 0 0 5px rgba(0, 0, 0, .13333);
    width: 100%;
    top: 0;
    z-index: 3002;

    > .flex {
        height: 100%;
    }

    &.is-extra-button {
        > .wrapper {
            padding-right: 134px;
        }

        .button-signout {
            position: absolute;
            padding: 6px 16px;
            right: 0;
        }
    }

    &.is-simple {
        height: 108px;
        
        .logo-default {
            display: none;
        }

        .navigation-info {
            display: none;
        }
        
        .button-signout {
            display: none;
        }

        > .flex {
            justify-content: center;
        }
    }

    @media (max-width: $screen-page-large) {
        &.is-extra-button {
            > .wrapper {
                padding-right: 160px;
            }

            .button-signout {
                right: $value-wrapper-padding-laptop;
            }
        }
    }

    @media (max-width: $screen-tablet) {
        &.is-extra-button {
            > .wrapper {
                padding-right: 150px;
            }
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        height: $value-height-header-mobile;

        &.is-simple {
            height: 64px;
        }

        &.is-extra-button {
            > .wrapper {
                padding-right: 62px;
            }

            .button-signout {
                right: $value-wrapper-padding-mobile;
                padding: 5px 5px 4px;

                > span {
                    display: none;
                }

                > img {
                    display: inline-block;
                }
            }
        }
    }
}
</style>